export const formatDateByLanguage = ( date, lang, withTime = false) => {
  const locales = {
    en: "en-US",
    ru: "ru-RU",
    fr: "fr-FR",
    am: "hy-AM",
  };

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone,
  };

  if (withTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
  }

  return new Date(date).toLocaleString(
    locales[lang] || "en-US",
    options
  );
};